export default __webpack_public_path__ + "static/20-megacorporation-7835d5e5e4b44ead78aa10b308845646.png";